import { Route } from 'sitemap';

export const getCSAPlusProjectDetailsRoutes = (projectId: string): Route[] => {
  const encodedId = encodeURIComponent(projectId);
  return [
    {
      name: 'Back to All Projects',
      icon: 'arrow-left',
      path: '/csa+/all-projects',
      active: true
    },
    {
      name: 'Project Details',
      icon: 'home',
      path: `/csa+/project-details/${encodedId}`,
      active: true
    },
    {
      name: 'Update Project',
      icon: 'edit',
      path: '/csa+/update-project',
      active: true
    }
  ];
};

export const getCSAPlusRoutes = (): Route[] => {
  const userId = localStorage.getItem('userId') || '';
  const userRole = (localStorage.getItem('role') || '').toLowerCase();
  const storedProjectId = localStorage.getItem('projectId');

  const routes: Route[] = [
    {
      name: 'Dashboard',
      icon: 'home',
      path: '/csa+',
      active: true
    },
    {
      name: 'Create New Project',
      icon: 'plus-circle',
      path: '/csa+/create-project',
      active: true
    }
  ];

  if (userRole !== 'developer' && userId) {
    routes.push({
      name: 'All Projects',
      icon: 'folder',
      path: '/csa+/all-projects',
      active: true
    });
  }

  routes.push(
    {
      name: 'Reviewer / Audit',
      icon: 'clipboard',
      path: storedProjectId ? `/csa+/project-details/${encodeURIComponent(storedProjectId)}` : '/csa+/all-projects',
      active: true
    },
    {
      name: 'AI Assurance 360',
      icon: 'shield',
      path: '/csa+/ai-assurance',
      active: true
    }
  );

  return routes;
};
